import { HttpInterceptor } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor{

  constructor(private injector : Injector) { }

  intercept(req,next){
    // Skip setting headers for payment/achallan/payment_data API
    if (req.url.includes('payment/achallan/payment_data')) {
      return next.handle(req);
    }

    let authService=this.injector.get(AuthService)
    let dataSource = this.injector.get(DataService);
    // The layout/header can issue requests before the lazy user-panel module
    // has initialized MODULE_ASSESSMENT_YEAR.  Keep the header valid during
    // that first render by falling back to the persisted assessment year.
    let module = dataSource.getData('MODULE_ASSESSMENT_YEAR')
      || localStorage.getItem('CURRENT_ASSESSMENT_YEAR')
      || '';
    const token = authService.getToken();
    const headers: any = {
      'Assessment-Year': module ? module : ''
    };
    if (token) {
      headers.Authorization = 'Bearer ' + token;
    }
    if (req.url.includes('/api/captcha/get-status')) {
      return next.handle(req);
    }
    let tokenizedReq=req.clone({
      setHeaders: headers
    })
    return next.handle(tokenizedReq)
  }
}
